import { render, staticRenderFns } from "./TabPaddock.vue?vue&type=template&id=08ff07b8"
import script from "./TabPaddock.vue?vue&type=script&lang=js"
export * from "./TabPaddock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports